import Image from 'next/legacy/image';

import { H3 } from '../../common/headline';

import eimear from '@public/img/our-story/eimear.svg';

export const EimearQuote = (): JSX.Element => (
  <div className="flex flex-col rounded-[24px] bg-dawn-blue-100 p-6 text-blue shadow-[0_40px_60px_0px_rgba(9,37,48,0.1)]">
    <div className="mb-2">
      <Image src={eimear} width={221} height={57} alt="Eimear" />
    </div>
    <H3>
      Our programme has been clinically proven to help 9/10 people lose weight
      and keep it off.
    </H3>
  </div>
);
